import React from "react";
import Header from "../components/Header";
import NavigationSideBar from "../components/NavigationSideBar";
import InnerBody from "../components/InnerBody";
import withAuthorization from "../firebase/withAuthorization";
import { listUsers } from "../firebase/firestore";
import withAccount from "../utils/withAccount";
import { dateToStringShort } from "../utils/DateHelper";
import Table from "../components/Table";
import TitleBar from "../components/TitleBar";
import RaisedButton from "../components/RaisedButton";
import FlatButton from "../components/FlatButton";
import { getUserAvatarUrl } from "../firebase/storage";
import withProfile from "../utils/withProfile";
import TextInput from "../components/TextInput";
import Dialog from "../components/Dialog";

class PageUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      users: [],
      editMode: false,
      delUser: { name: "" },
      delUserDialogShow: false,
      addUserDialogShow: false
    };
  }

  componentDidMount() {
    const { account } = this.props;

    listUsers(
      account.id,
      docs => {
        let users = [];
        docs.forEach(element => {
          const data = element.data();
          users.push({
            id: element.id,
            name: `${data.first} ${data.last}`,
            accession: data.accession
          });
        });
        this.setState({ users: users, isLoading: false });
      },
      error => {
        console.log(error);
        this.setState({ users: [] });
      }
    );
  }

  createUserDataArray() {
    const { account } = this.props;
    const { users, editMode } = this.state;

    let data = [];

    users.forEach(u => {
      const isAdmin = account.admin === u.id;
      data.push({
        items: [
          <span className="AlignVerti">
            <UserPicture userId={u.id} me={this.props.profile.id} />
            <div className="Spacer-HS" />
            {u.name}
          </span>,
          this.getUserRole(u.id),
          "Vollzugriff",
          dateToStringShort(u.accession.toDate()),
          editMode ? (
            <RaisedButton
              label="Entfernen"
              theme="bad"
              disabled={isAdmin}
              onClick={() => this.removeUser(u)}
            />
          ) : null
        ]
      });
    });

    return data;
  }

  /*
    <p className="Link">
      <i className="fas fa-clipboard-list" />
      &nbsp; Aktivitäten
    </p>
  */

  getUserRole(userId) {
    const { account } = this.props;
    if (userId === account.admin) {
      return (
        <strong style={{ color: "var(--color-bad)" }}>Kontoinhaber</strong>
      );
    } else {
      return <p style={{ color: "var(--color-stateless)" }}>Normaler Nutzer</p>;
    }
  }

  edit() {
    const { account, profile } = this.props;
    const amIAdmin = account.admin === profile.id;
    if (amIAdmin) {
      this.setState({ editMode: !this.state.editMode });
    } else {
      alert("Die Nutzerliste kann nur vom Kontoinhaber bearbeitet werden.");
    }
  }

  removeUser(user) {
    this.setState({ delUserDialogShow: true, delUser: user });
  }

  render() {
    const { account } = this.props;
    const {
      editMode,
      delUser,
      delUserDialogShow,
      addUserDialogShow
    } = this.state;

    return (
      <div>
        <Header
          title="Nutzer"
          showProjectsDropdown={false}
          showProfile={true}
          history={this.props.history}
        />
        <NavigationSideBar page="users" />
        <InnerBody isLoading={this.state.isLoading}>
          <TitleBar title="Nutzerliste">
            <FlatButton
              label={editMode ? "Fertig" : "Bearbeiten"}
              onClick={() => this.edit()}
            />
          </TitleBar>
          <Table
            header={[
              {
                items: ["Name", "Rolle", "Rechte", "Beitritt", ""]
              }
            ]}
            onItemSelected={(index, col) => {}}
            colSelectables={[]}
            data={this.createUserDataArray()}
          >
            {null}
          </Table>
          {editMode ? (
            <TitleBar>
              <RaisedButton
                label="Neuen Nutzer hinzufügen"
                onClick={() => this.setState({ addUserDialogShow: true })}
              />
            </TitleBar>
          ) : null}
        </InnerBody>

        <Dialog
          visible={addUserDialogShow}
          title="Nutzer Hinzufügen [n/a]"
          action="Hinzufügen"
          onClose={() => this.setState({ addUserDialogShow: false })}
        >
          <TextInput
            placeholder="E-Mail"
            validation="email"
            ref={this.refAddEmail}
          />
          <p>&nbsp;</p>
        </Dialog>

        <Dialog
          visible={delUserDialogShow}
          title="Nutzer Entfernen [n/a]"
          theme="bad"
          action="Entfernen"
          onClose={() => this.setState({ delUserDialogShow: false })}
        >
          Möchten Sie <strong>{delUser.name}</strong> wirklich von{" "}
          {account.name} ausschließen? Dem Nutzer werden mit sofortiger Wirkung
          alle Rechte entzogen und der Zugriff auf {account.name} verwehrt.
        </Dialog>
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;
export default withAuthorization(authCondition)(
  withAccount(withProfile(PageUsers))
);

class UserPicture extends React.Component {
  constructor(props) {
    super(props);
    this.state = { src: null };
  }

  componentDidMount() {
    getUserAvatarUrl(
      this.props.userId,
      url => {
        this.setState({ src: url });
      },
      error => {}
    );
  }

  render() {
    const { userId, me, history } = this.props;
    const isMe = userId === me;

    return (
      <img
        alt=""
        className="UserAvatar"
        src={this.state.src}
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          borderColor: "var(--color-link)",
          borderStyle: isMe ? "solid" : "none"
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageUsers.js